import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { areShareableFolderModels, isShareableFolderModel } from '../utils/typeGuards';
import { assertNever } from 'owa-assert';
import { createdNewFolder, foldersLoaded } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(foldersLoaded, actionMessage => {
    const { folders } = actionMessage;

    const store = getStore();

    switch (store.selectedProviderType) {
        case AttachmentDataProviderType.OneDrivePro:
            if (areShareableFolderModels(folders)) {
                // If the store contains one drive folders
                // then only set the appropriate folder model
                store.folders = folders;
            }
            return;

        default:
            return assertNever(store.selectedProviderType);
    }
});

mutator(createdNewFolder, actionMessage => {
    const { folder } = actionMessage;

    const store = getStore();

    switch (store.selectedProviderType) {
        case AttachmentDataProviderType.OneDrivePro:
            if (isShareableFolderModel(folder)) {
                // Create a new list with the newly created folder
                // sort it and then assign it back.
                const folders = [...store.folders, folder];

                // TODO: See if we are going to do any other sorting because in that case we
                // will have to sort it appropriately
                folders.sort((f1, f2) => f1.name.localeCompare(f2.name));
                store.folders = folders;
            }
            return;
        default:
            return assertNever(store.selectedProviderType);
    }
});
